import {Promise} from 'es6-promise';
import axios from 'axios';
// import { encryptDes, decryptDes } from '../des/DESUtils'
import store from '@/store/index'
import NProgress from 'nprogress' // 引入nprogress插件

import { Notification} from "element-ui";


export const webSocketUrl = 'ws://39.107.240.59:9090/ws'; //测试服务器
// export const webSocketUrl = 'ws://192.168.0.105:9090/ws'; //本地测试
// export const webSocketUrl = 'ws://127.0.0.1:9090/ws'; //本地测试
const instance = axios.create({
  // baseURL: 'http://127.0.0.1:20044/',          // 本地测试
   baseURL: 'http://tax.fajiankeji.com:20044/',          // 本地测试
  // baseURL: 'http://39.107.240.59:20044/', // 测试服务器

  timeout: 60000,                                // 请求超时设置
  headers: {"Accept": "application/json"}
});
var instanced = true;
// 请求拦截
instance.interceptors.request.use(result => {
  NProgress.start();
  if(store.state.userInfo.userToken && store.state.userInfo.userToken !== 'null' && store.state.userInfo.userToken !== 'undefined') {
    result.headers['X-ACCESS-TOKEN'] = store.state.userInfo.userToken;
  }else{
    console.log('未登录')
  }
  return result
}, error => {
  return Promise.reject(error)
});

instance.interceptors.response.use(response => {
  NProgress.done();

  if(response.data.code == 400 && instanced){
    instanced = false;
    Notification({
      title: '登录已失效',
      type: 'warning',
      message: '登录已失效,即将跳转至登录页面',
      onClose: function () {
        instanced = true;
      }
    });
    localStorage.clear();
    setTimeout(function(){
      let nowHref = location.href;
      let arr = nowHref.split('?');
      let targetHref = '';
      targetHref = arr[0] + '?reLoginX=yes'
      if(arr.length > 1){
        targetHref = targetHref + '&' + arr[1]
      }
      window.location.href = targetHref;
    },2000);
    return response;
  }
    return response

}, error => {
  if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
    Notification({
      title: '请求连接超时',
      type: 'error',
      message: '超时服务器未响应，请检查您的网络',
      duration: 60
    });
    NProgress.done();
    return Promise.reject(error);          // reject这个错误信息
  }
  NProgress.done();
  return Promise.reject(error)
});


// 顶层loding 开 / 关
export const openTopLoding = function() {
  store.commit('loading/loadSta',true);
};
export const closeTopLoding = function() {
  store.commit('loading/loadRed', null);
};


export default instance;



// WEBPACK FOOTER //
// ./src/api/api.js